module.exports = __webpack_public_path__ + "img/4-1.9ec40371.png";